import React, { PropTypes } from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton'
import Paper from 'material-ui/Paper';

class SpeedDialItem extends React.Component {
  static propTypes = {
    label: PropTypes.node,
    icon: PropTypes.node.isRequired,
    secondary: PropTypes.bool,
    onClick: PropTypes.func.isRequired
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  state = {
    show: false
  };

  _showLabel = () => {
    this.setState({show: true});
  };

  _hideLabel = () => {
    this.setState({show: false});
  };


  render() {
    let { label, icon, onClick } = this.props;
    let { show } = this.state;

    const {
      floatingActionButton: { color, iconColor }
    } = this.context.muiTheme;

    // styles
    const itemStyle = {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      padding: 8
    };

    const labelStyle = {
      boxSizing: 'border-box',
      marginRight: 10,
      width: show ? 200 : 0,
      height: show ? 'auto' : 0,
      overflow: 'hidden'
    };

    const labelStyleInner = {
      padding: 8,
      textAlign: 'center',
      backgroundColor: color,
      color: iconColor,
      fontSize: 14
    };

    return (
      <div style={itemStyle} onClick={onClick}
           onMouseEnter={this._showLabel}
           onMouseLeave={this._hideLabel}
      >
        {label
          ? (<div style={labelStyle}><Paper zDepth={3} style={labelStyleInner}>{label}</Paper></div>)
          : null
        }
        <FloatingActionButton mini={true} secondary={false}>{icon}</FloatingActionButton>
      </div>
    );
  }
}

export default SpeedDialItem;




// WEBPACK FOOTER //
// ./src/components/SpeedDial/SpeedDialItem.js